<div class="alerts-container">
    <div class="d-flex align-items-center">
        <div class="d-flex flex-column alerts-filters-container">
            <div class="alerts-filters-container">
                <span>Filter:</span>
                <span (click)="filterManagedClicked(undefined)" class="alerts-filter"
                    [ngClass]="{'active': managedFilter == undefined}">Show all</span>
                <span (click)="filterManagedClicked(true)" class="alerts-filter"
                    [ngClass]="{'active': !!managedFilter}">Show
                    managed</span>
                <span (click)="filterManagedClicked(false)" class="alerts-filter me-4"
                    [ngClass]="{'active': managedFilter == false}">Show no managed</span>
            </div>
            <div class="alerts-filters-container">
                <span>Date:</span>
                <span (click)="filterAllTimeDateClicked()" class="alerts-filter"
                    [ngClass]="{'active': !!allTimeButton}">All time</span>
                <span (click)="filterThisMonthDateClicked()" class="alerts-filter"
                    [ngClass]="{'active': !!thisMonthButton}">This month</span>
                <span (click)="filterThisYearDateClicked()" class="alerts-filter"
                    [ngClass]="{'active': !!thisYearButton}">This year</span>
            </div>
        </div>
        <app-paginator #alertsPaginator (pageChange)="loadAlerts()"></app-paginator>
        <button (click)="createAlert()" class="ms-3 button mini">
            <mat-icon>add</mat-icon>
            Create
        </button>
    </div>
    <div class="table-container mt-4">
        <table class="ip-table">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Status</th>
                    <th>IP</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="alerts.length === 0"><td colspan="5">No block policies yet.</td></tr>
                <tr *ngFor="let alert of alerts">
                    <td>{{ alert.attacks![0].type }}</td>
                    <td>{{ utils.getStatus(alert) }}</td>
                    <td>{{ alert.attacks![0].sourceAddresses.split(',').join(', ') }}</td>
                    <td class="ip-table-actions">
                        <button (click)="onRetryButtonClicked(alert)" *ngIf="utils.getStatus(alert) == 'Pending'" class="button mini">Retry</button>
                        <button (click)="onDeleteButtonClicked(alert)" class="button mini">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>